// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"161":"8602f7a9","192":"5133eac3","482":"a91b6ad6","819":"1790834e"}[chunkId] + ".css";
};